export const resolvePanelType = (type, heatingSys = '') =>
  type || (heatingSys.includes('ess') ? 'switch' : 'blower');
